import { Middleware } from './middleware'
import store from '@/store'
import jwt_decode from "jwt-decode";
import router from '@/router'

export default {
    async auth(body, recaptcha) {
        const response = await new Middleware()
            .append('/auth/login')
            .method('POST')
            .params({
                'g-recaptcha-response': recaptcha
            })
            .setData(body)
            .build()
        let bodyAuth = {
            token: null,
            refresh_token: null,
            email: null,
            roles: [],
            name: '',
            exp: null,
        }
        const jwt = jwt_decode(response.data.access_token);
        bodyAuth.token = response.data.access_token
        bodyAuth.email = jwt.sub
        bodyAuth.name = jwt.name
        bodyAuth.roles = jwt.roles
        bodyAuth.exp = jwt.exp
        store.commit('auth/setData', bodyAuth)
    },

    lostPassword(username, recaptcha) {
        return new Middleware()
            .append(`/auth/reset_password/${username}`)
            .params({
                'g-recaptcha-response': recaptcha
            })
            .method('PUT')
            .build()
    },

    verifyTokenLostPassword(token) {
        return new Middleware()
            .append(`/auth/validate?token=${token}`)
            .method('GET')
            .build()
    },

    registerNewPassword(data, recaptcha) {
        return new Middleware()
            .append(`/auth/new_password`)
            .params({
                'g-recaptcha-response': recaptcha
            })
            .method('POST')
            .setData(data)
            .build()

    },

    refreshToken() {
        return new Middleware()
            .append(`/auth/refresh/`)
            .method('POST')
            .build()
    },


    isAuthenticated() {
        if (store.getters['auth/token'] == null) {
            return false;
        }
        const exp = new Date(Number(store.getters['auth/exp'])) * 1000;
        return exp > new Date()
    },

    getToken() {
        if (!this.isAuthenticated() && store.getters['auth/token'] != null) {
            // this.refreshToken();
            store.commit('auth/logout')
            router.push('/')
            store.commit("utils/setOpenNav", false)

        }
        return store.getters['auth/token'];
    }
}